// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3Jyo6","additionalInfo":"AgreementModal_additionalInfo__3ociL"};